function initCspDropdowns() {
  document.querySelectorAll('.collections-dropdown-menu').forEach(menu => {
    // prevent duplicate binding
    if (menu.dataset.cspInit === 'true') return;
    menu.dataset.cspInit = 'true';

    const links = menu.querySelectorAll('.mm-collection-link');
    const grids = menu.querySelectorAll('.mm-product-grid');

    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const handle = link.dataset.collectionHandle;
        links.forEach(l => l.classList.remove('active'));
        grids.forEach(g => g.classList.remove('active'));

        link.classList.add('active');
        const target = menu.querySelector(`.mm-product-grid[data-collection-grid="${handle}"]`);
        if (target) target.classList.add('active');
      });
    });
  });
}

// fire on all possible navigation/section events
document.addEventListener('DOMContentLoaded', initCspDropdowns);
document.addEventListener('shopify:section:load', initCspDropdowns);
document.addEventListener('shopify:section:select', initCspDropdowns);
document.addEventListener('page:load', initCspDropdowns);
